import React, { Component } from "react";
import axios from "axios";
import Conf from "./Conf";

class Auth extends Component {
  GetURLParameter(sParam) {
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split("&");
    for (var i = 0; i < sURLVariables.length; i++) {
      var sParameterName = sURLVariables[i].split("=");
      if (sParameterName[0] === sParam) {
        return sParameterName[1];
      } else {
        return null;
      }
    }
  }
  componentDidMount() {
    var ref = this.GetURLParameter("ref");
    console.log(ref);
    if (ref) {
      axios
        .get(Conf.signinURL + "token/" + ref, {
          headers: { "X-Requested-With": "profile" },
        })
        .then(async (res) => {
          console.log(res.data);
          if (res.data.token) {
            let cookie = localStorage.getItem(Conf.cookieName);
            cookie = JSON.parse(cookie);
            cookie = { ...cookie, admin_token: res.data.token };
            localStorage.setItem(Conf.cookieName, JSON.stringify(cookie));
            window.location = Conf.frontendURL + "patron";
          } else {
            window.location = Conf.frontendURL + "login";
          }
        });
    } else {
      localStorage.removeItem(Conf.cookieName);
      var callback = Conf.frontendURL + "login";
      axios
        .post(Conf.signinURL + "login", { callback: callback })
        .then((res) => {
          if (res.data && res.data.login_url)
            window.location = res.data.login_url;
        });
    }
  }
  render() {
    return <React.Fragment></React.Fragment>;
  }
}
export default Auth;
